import { render, staticRenderFns } from "./FormatSortSelector.vue?vue&type=template&id=ae9c784c&scoped=true&"
import script from "./FormatSortSelector.vue?vue&type=script&lang=ts&"
export * from "./FormatSortSelector.vue?vue&type=script&lang=ts&"
import style0 from "./FormatSortSelector.vue?vue&type=style&index=0&id=ae9c784c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae9c784c",
  null
  
)

export default component.exports